import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import { Select } from "antd";

const { Option } = Select;

const MessageReport = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [messageFromId, setMessageFromId] = useState("");
  const [messageToId, setMessageToId] = useState("");
  const [userList, setUserList] = useState([]);
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    fetchReport();
  }, [OptionDownload]);

  /* === GREEN :: API INTEGRATED === */
  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      message_from_user: messageFromId,
      message_to_user: messageToId,
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(ApiConfig.MESSAGE_REPORT, JSON.stringify(body))
      .then((res) => {
        if (res?.result) {
          setUserList(res?.masteruser || []);
          setOrderListData(res?.message_thread || []);
        } else {
          setUserList([]);
          setOrderListData([]);
        }
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  const getUserName = (id) => {
    const u = userList.find((x) => x.user_id === id);
    return u ? `${u.user_name || ""} ${u.user_last_name || ""}`.trim() : id;
  };

  const handleClear = () => {
    setMessageFromId("");
    setMessageToId("");
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>{t("Message Report")}</p>
                </p>
              </div>

              {/* === GREEN :: UI UPDATED (Select Message From / Select Message To) === */}
              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "220px" }}
                  className="custom-select"
                  placeholder={t("Select Message From")}
                  value={messageFromId || undefined}
                  onChange={(value) => setMessageFromId(value)}
                  showSearch
                  allowClear
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  {userList?.map((u) => (
                    <Option
                      key={u.user_id}
                      value={u.user_id}
                      label={`${u.user_name || ""} ${u.user_last_name || ""}`.trim()}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {u.user_name} {u.user_last_name}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "220px" }}
                  className="custom-select"
                  placeholder={t("Select Message To")}
                  value={messageToId || undefined}
                  onChange={(value) => setMessageToId(value)}
                  showSearch
                  allowClear
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  {userList?.map((u) => (
                    <Option
                      key={u.user_id}
                      value={u.user_id}
                      label={`${u.user_name || ""} ${u.user_last_name || ""}`.trim()}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {u.user_name} {u.user_last_name}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="innerSelectBox">
                <button
                  type="button"
                  className="btn btn-success"
                  style={{ height: "40px" }}
                  onClick={fetchReport}
                >
                  {t("Search")}
                </button>
              </div>

              <div className="innerSelectBox">
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ height: "40px" }}
                  onClick={handleClear}
                >
                  {t("Clear")}
                </button>
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {/* === GREEN :: API INTEGRATED (table mapped to message_thread response) === */}
            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("From")}</th>
                  <th>{t("To")}</th>
                  <th>{t("Subject")}</th>
                  <th>{t("Date & Time")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {OrderListData && OrderListData?.length > 0
                    ? OrderListData.map((item, index) => (
                        <tr className="text-center" key={item.message_thread_id || index}>
                          <td>{index + 1}</td>
                          <td>{getUserName(item.message_thread_from_id)}</td>
                          <td>{getUserName(item.message_thread_to_id)}</td>
                          <td>{item.message_thread_subject}</td>
                          <td>{item.message_thread_date_time}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {OrderListData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MessageReport;
